import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({

    btnAccept: {
        fontSize: '18px',
        fontWeight: 'bold',
        backgroundColor: '#2ca01c',
        marginLeft: "12px",
        textTransform: 'none',
        width: '100%',
        marginTop: '10px',
        '&:hover': {
            background: '#2ca01c',
        },
        '&.MuiButton-contained.Mui-disabled': {
            background: '#7bb374',
            color: 'white'
        }
    },
    btnBack: {
        fontSize: '18px',
        fontWeight: 'bold',
        textTransform: 'none',
        width: '100%',
        marginRight: '10px',
        marginTop: '10px',
    },
    btnClear: {
        opacity: "0.5"
    },
    btnSection: {
        marginTop: '12px',
        display: 'flex',
        justifyContent: 'space-between'
    },

    btnGrid: {
        marginTop: '6px',
        marginBottom: '6px'
    },
    fieldColor: {
        '& :after': {
            borderBottomColor: '#2ca01c',
        },
        '& :before': {
            borderBottomColor: '#2ca01c',
        },
        color: 'green !important',
        '& label.Mui-focused': {
            color: '#2ca01c',
        },
        '&.Mui-focused fieldset': {
            borderColor: '#2ca01c',
        },
        '@global': {
          '.MuiInput-formControl': {
            marginTop: '48px !important'
          }
        }
    },
    textSize: {
        fontSize: '20px',
    },
    inputField: {
        borderBottom: '2px solid #2ca01c',
        fontSize: '20px'
    },
    textLabel: {
        color: '#676767'
    },
    inputField: {
        background: '#E8E8E8'
    },
    inputGrid: {
        marginTop: '10px'
    },
    root: {
        marginTop: '16px',
        '@global': {
            '.MuiTypography-h6': {
            fontWeight: 600
            }
        }
    },
    upload: {
        boxShadow: 'none',
        width: '89px',
        height: '89px',
        zIndex: '100',
        padding: '5px',
        outline: 'none',
        display: 'inline-block',
        borderRadius: '100%',
        position: 'relative'
    },
    progress : {
        width: '100%',
        '& > * + *': {
            marginTop: theme.spacing(2),
        },
    },
    paper: {
        position: 'relative',
        height: 'auto',
        marginBottom: '10px',
        padding: '10px 8px',
        border: '1px solid #ddd',
        boxSizing: 'border-box',
        marginTop: '20px',
        flexBasis: '100%'
    },
    container: {
        justifyContent: 'center',
        textAlign: 'center',
        marginTop: '25px',
        outline: 'none',
        position: 'relative'
    },
    left: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    
    thumbsContainer: {
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
    },
    thumb: {
        display: 'flex',
        borderRadius: 2,
        border: '1px solid #eaeaea',
        marginBottom: 8,
        marginRight: 8,
        width: 'inherit',
        height: 'inherit',
        padding: 4,
        boxSizing: 'border-box',
        position: 'relative'
    },
    thumbInner: {
        display: 'flex',
        minWidth: 0,
        overflow: 'hidden',
    },
    img: {
        display: 'block',
        width: '100%',
        height: '100%'
    },
    remove: {
        position: 'absolute',
        top: '-14px',
        width: '0',
        height: '0',
        right: '12px',
        cursor: 'pointer'
    },
    btnContinue: {
        fontSize: '22px',
        width: '30vw',
        height: '38px',
        textTransform: 'none',
        fontSize: '14px',
        padding: '5px 20px',
        fontWeight: 'bold',
        backgroundColor: '#2ca01c',
        textTransform: 'none',                      
        '&:hover': {
            background: '#2ca01c',
        },
    },
    documentPreview: {
        margin: '15px',
        boxSizing: 'border-box',
    },
    firstDropzone: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        width: '100%',
        height: 'auto',
        cursor:'pointer'
    },
    loader: {
        position: 'absolute',
        textAlign: 'center',
        left: '47%',
        top: '50%'
    },
    error: {
        color: 'red',
        marginTop: '20px',
        marginBottom: '10px'
    },
    progress: {
        height: '120px',
        width: '120px'
    },
    circle: {
        borderRadius: '50%',
        border: '1px solid #2ca01c',
        width: '130px',
        height: '130px',
        boxShadow: theme.shadows[2],
        position: 'absolute',
        opacity: '0',
        top: '0',
        animation: `$scaleIn 4s infinite cubic-bezier(.36, .11, .89, .32)`,
    },
    '@keyframes scaleIn': {
        "from": {
            transform: 'scale(.5, .5)',
            opacity: '.5'
        },
        "to": {
            transform: 'scale(1.5, 1.5)',
            opacity: '0'
        }
    },
    upload: {
        boxShadow: 'none',
        width: '130px',
        height: '130px',
        zIndex: '100',
        padding: '5px',
        outline: 'none',
        display: 'inline-block',
        borderRadius: '100%',
        position: 'relative'
    },
    icon: {
        color: '#2ca01c',
        position: 'relative',
        display: 'flex',
        width: '100%',
        fontSize: '50px'
    },
    button: {
        fontWeight: 'bold',
        borderRadius: '28px',
        textTransform: 'none',
        fontFamily: 'Avenir-Regular',
        marginTop: '10px',
        outline: 'none'
    },
    animate: {
        display: 'flex',
        width: '100%',
        justifyContent: 'center'
    },
    image: {
        width: '100px',
        height: '100px',
        display: 'inline-block',
        borderRadius: '100%'
    },
    percentage: {
        color: '#2ca01c',
        fontWeight: 'bold',
        fontSize: '18px'
    },
    template: {
        color: 'gray',
        cursor: 'pointer',
        fontSize: '0.84rem'
    },
    description: {
        color: '#2ca01c'
    },
    RadioBtn : {
        '@global': {
            '.MuiTypography-body1': {
                paddingTop: '3px'
            }
        }
    }
}));


export default useStyles;
